import * as actionTypes from './redux.actionTypes';

// Fetch all menus
export const fetchMenus = () => ({
    type: actionTypes.FETCH_MENUS
});

export const fetchMenusSuccess = (payload) => ({
    type: actionTypes.FETCH_MENUS_SUCCESS,
    payload
});

export const fetchMenusFailure = (error) => ({
    type: actionTypes.FETCH_MENUS_FAILURE,
    payload: error
});

// Fetch menu by ID
export const fetchMenuById = (menuId) => ({
    type: actionTypes.FETCH_MENU_BY_ID,
    payload: { menuId }
});

export const fetchMenuByIdSuccess = (payload) => ({
    type: actionTypes.FETCH_MENU_BY_ID_SUCCESS,
    payload
});

export const fetchMenuByIdFailure = (error) => ({
    type: actionTypes.FETCH_MENU_BY_ID_FAILURE,
    payload: error
});

// Create menu
export const createMenu = (payload) => ({
    type: actionTypes.CREATE_MENU,
    payload
});

export const createMenuSuccess = (payload) => ({
    type: actionTypes.CREATE_MENU_SUCCESS,
    payload
});

export const createMenuFailure = (error) => ({
    type: actionTypes.CREATE_MENU_FAILURE,
    payload: error
});

// Update menu
export const updateMenu = (menuId, payload) => ({
    type: actionTypes.UPDATE_MENU,
    payload: { menuId, data: payload }
});

export const updateMenuSuccess = (payload) => ({
    type: actionTypes.UPDATE_MENU_SUCCESS,
    payload
});

export const updateMenuFailure = (error) => ({
    type: actionTypes.UPDATE_MENU_FAILURE,
    payload: error
});

// Delete menu
export const deleteMenu = (menuId) => ({
    type: actionTypes.DELETE_MENU,
    payload: { menuId }
});

export const deleteMenuSuccess = (menuId) => ({
    type: actionTypes.DELETE_MENU_SUCCESS,
    payload: { menuId }
});

export const deleteMenuFailure = (error) => ({
    type: actionTypes.DELETE_MENU_FAILURE,
    payload: error
});

// Fetch permissions
export const fetchPermissions = () => ({
    type: actionTypes.FETCH_PERMISSIONS
});

export const fetchPermissionsSuccess = (payload) => ({
    type: actionTypes.FETCH_PERMISSIONS_SUCCESS,
    payload
});

export const fetchPermissionsFailure = (error) => ({
    type: actionTypes.FETCH_PERMISSIONS_FAILURE,
    payload: error
});

// UI actions
export const openMenuDialog = (menu = null) => ({
    type: actionTypes.OPEN_MENU_DIALOG,
    payload: menu
});

export const closeMenuDialog = () => ({
    type: actionTypes.CLOSE_MENU_DIALOG
});

export const openDeleteDialog = (menuId) => ({
    type: actionTypes.OPEN_DELETE_DIALOG,
    payload: menuId
});

export const closeDeleteDialog = () => ({
    type: actionTypes.CLOSE_DELETE_DIALOG
});

export const setSelectedMenu = (menu) => ({
    type: actionTypes.SET_SELECTED_MENU,
    payload: menu
});

export const clearSelectedMenu = () => ({
    type: actionTypes.CLEAR_SELECTED_MENU
});
